/* EGD: free shipping top bar + cart page card (replaces the Essential Free Shipping app).
   Loaded on every page (snippets/egd-free-shipping-bar.liquid).
   - Both are rendered on the server from cart.total_price. This script keeps them in step
     with any cart change made on the page: theme jQuery cart calls, quick shop, apps using
     fetch or XMLHttpRequest to /cart/add|change|update|clear, and theme cart events.
   - Card carousel: CSS container queries pick 1-4 slides per view from the card's own
     width; arrows scroll by one slide and are hidden when every slide fits.
   - Card "Add to cart" posts to /cart/add.js asking for the cart section HTML (Section
     Rendering API) and updates the section in place, no reload. The wallet buttons block
     is left untouched (never moved). If the swap is not possible it falls back to a reload. */
(function () {
  'use strict';
  if (window.__egdFreeShipping) return;
  window.__egdFreeShipping = true;

  var bar = document.querySelector('[data-egd-fs-bar]');
  var barText = bar && bar.querySelector('[data-egd-fs-bar-text]');
  var card = document.querySelector('[data-egd-fs-card]');
  if (!bar && !card) return;

  function rate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c ? parseFloat(c.rate) : 1;
    return r > 0 ? r : 1;
  }
  function formatMoney(cents) {
    var fmt = document.body.getAttribute('data-money-format') || '${{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, fmt); } catch (e) {}
    }
    var parts = (cents / 100).toFixed(2).split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withCommas;
      if (k === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      if (k === 'amount_no_decimals_with_comma_separator') return parts[0];
      return withCommas + '.' + parts[1];
    });
  }
  // el carries data-threshold (shop currency cents) and the three texts.
  function message(el, total, count) {
    var threshold = Math.round(parseInt(el.getAttribute('data-threshold'), 10) * rate());
    var left = threshold - total;
    var text = count === 0
      ? el.getAttribute('data-empty-text')
      : left > 0
        ? el.getAttribute('data-progress-text').replace('[amount]', formatMoney(left))
        : el.getAttribute('data-success-text');
    var pct = threshold > 0 && left > 0 ? Math.floor(total * 100 / threshold) : 100;
    if (count === 0) pct = 0;
    return { text: text, pct: pct };
  }

  /* ---------- card ---------- */
  var msgEl, fillEl, track, prevBtn, nextBtn, slides = [];
  function updateArrows() {
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var fits = max <= 1;
    card.classList.toggle('egd-fs-card--fits', fits);
    prevBtn.disabled = fits || track.scrollLeft <= 1;
    nextBtn.disabled = fits || track.scrollLeft >= max - 1;
  }
  function step(dir) {
    var first = slides.filter(function (s) { return !s.hidden; })[0];
    if (!first) return;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({ left: dir * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }
  var resizeObs = window.ResizeObserver ? new ResizeObserver(function () { updateArrows(); }) : null;
  function initCard(el) {
    if (resizeObs && track) resizeObs.unobserve(track);
    card = el;
    if (!card) return;
    msgEl = card.querySelector('[data-egd-fs-msg]');
    fillEl = card.querySelector('[data-egd-fs-fill]');
    track = card.querySelector('[data-egd-fs-track]');
    prevBtn = card.querySelector('[data-egd-fs-prev]');
    nextBtn = card.querySelector('[data-egd-fs-next]');
    slides = Array.prototype.slice.call(card.querySelectorAll('[data-egd-fs-slide]'));
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    if (resizeObs) resizeObs.observe(track);
    card.addEventListener('click', onAdd);
    updateArrows();
  }
  if (!resizeObs) window.addEventListener('resize', updateArrows);

  // Update the cart section in place with the HTML Shopify returns from /cart/add.js
  // (Section Rendering API). The wallet buttons block is never moved or replaced: moving
  // it reloads the PayPal iframe and PayPal draws its button twice. Only the nodes beside
  // the path down to the wallet block are replaced, and the elements on that path keep
  // their place and only get the fresh attributes.
  function syncAttrs(oldEl, newEl) {
    Array.prototype.slice.call(oldEl.attributes).forEach(function (a) {
      if (!newEl.hasAttribute(a.name)) oldEl.removeAttribute(a.name);
    });
    Array.prototype.slice.call(newEl.attributes).forEach(function (a) {
      if (oldEl.getAttribute(a.name) !== a.value) oldEl.setAttribute(a.name, a.value);
    });
  }
  function mergeAround(oldEl, newEl, keepOld, keepNew) {
    if (oldEl === keepOld) return true;
    var oldKids = Array.prototype.slice.call(oldEl.childNodes);
    var newKids = Array.prototype.slice.call(newEl.childNodes);
    var oi = -1, ni = -1;
    oldKids.forEach(function (n, i) { if (n.nodeType === 1 && n.contains(keepOld)) oi = i; });
    newKids.forEach(function (n, i) { if (n.nodeType === 1 && n.contains(keepNew)) ni = i; });
    if (oi < 0 || ni < 0) return false;
    var oPath = oldKids[oi], nPath = newKids[ni];
    if (oPath !== keepOld && (oPath.tagName !== nPath.tagName)) return false;
    // Replace everything before and after the path node.
    oldKids.forEach(function (n, i) { if (i !== oi) oldEl.removeChild(n); });
    newKids.slice(0, ni).forEach(function (n) { oldEl.insertBefore(n, oPath); });
    var after = oPath.nextSibling;
    newKids.slice(ni + 1).forEach(function (n) { oldEl.insertBefore(n, after); });
    if (oPath === keepOld) return true;
    syncAttrs(oPath, nPath);
    return mergeAround(oPath, nPath, keepOld, keepNew);
  }
  function swapSection(section, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById(section.id) || doc.body.firstElementChild;
    if (!fresh || !fresh.querySelector('[data-egd-fs-card]')) return false;
    var wallet = section.querySelector('.additional-checkout-buttons');
    var newWallet = fresh.querySelector('.additional-checkout-buttons');
    var y = window.scrollY;
    if (wallet && newWallet) {
      if (!mergeAround(section, fresh, wallet, newWallet)) return false;
    } else {
      section.replaceChildren.apply(section, Array.prototype.slice.call(fresh.childNodes));
    }
    window.scrollTo(0, y);
    initCard(section.querySelector('[data-egd-fs-card]'));
    return true;
  }
  function onAdd(e) {
    var btn = e.target.closest('[data-egd-fs-add]');
    if (!btn || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding...';
    var section = card.closest('.shopify-section');
    var sectionId = section ? section.id.replace(/^shopify-section-/, '') : '';
    var body = { items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }
    origFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        var html = data && data.sections && data.sections[sectionId];
        if (!html || !swapSection(section, html)) {
          window.location.reload();
          return;
        }
        refresh();
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      });
  }
  initCard(card);

  /* ---------- updates ---------- */
  function apply(total, count, productIds) {
    if (barText) {
      var b = message(bar, total, count);
      if (barText.textContent !== b.text) barText.textContent = b.text;
    }
    if (card) {
      var m = message(card, total, count);
      if (msgEl.textContent !== m.text) msgEl.textContent = m.text;
      fillEl.style.width = m.pct + '%';
      if (productIds) {
        slides.forEach(function (s) {
          s.hidden = productIds.indexOf(parseInt(s.getAttribute('data-product-id'), 10)) > -1;
        });
        card.classList.toggle('egd-fs-card--no-slides', !slides.some(function (s) { return !s.hidden; }));
        updateArrows();
      }
    }
  }
  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  var timer = null;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!origFetch) return;
      origFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          apply(c.total_price, c.item_count, c.items.map(function (it) { return it.product_id; }));
          Array.prototype.forEach.call(document.querySelectorAll('.cart_count'), function (el) {
            if (el.textContent !== String(c.item_count)) el.textContent = c.item_count;
          });
        })
        .catch(function () {});
    }, 150);
  }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function isCartUrl(u) {
    try { return CART_RE.test(new URL(u, location.href).pathname); } catch (e) { return false; }
  }
  if (window.fetch) {
    window.fetch = function (input) {
      var p = origFetch.apply(window, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isCartUrl(url)) p.then(refresh, function () {});
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartUrl(String(url))) {
        this.addEventListener('loadend', refresh);
      }
      return open.apply(this, arguments);
    };
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'theme:cart:change', 'ajaxProduct:added'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });
  // Shop currency other than the cart currency: recompute with the rate.
  if (rate() !== 1) {
    var el = bar || card;
    apply(parseInt(el.getAttribute('data-total'), 10), parseInt(el.getAttribute('data-count'), 10), null);
  }
  // Back/forward cache can show an old cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
